import { computeLine, sumLines, type LineAmounts } from '@his/shared';

export interface PricedBatch {
  qtyOnHand: number;
  priceMinor: number;
}

export interface PricedCartLine {
  qty: number;
  discountPct: number;
  priceMinor: number;
  taxPct: number;
  batches: PricedBatch[];
}

const NOTHING: LineAmounts = { gross: 0, discount: 0, taxable: 0, tax: 0, net: 0 };

function fefoParts(line: PricedCartLine): { priceMinor: number; qty: number }[] {
  const parts: { priceMinor: number; qty: number }[] = [];
  let remaining = line.qty;
  for (const batch of line.batches) {
    if (remaining <= 0) break;
    const take = Math.min(batch.qtyOnHand, remaining);
    if (take <= 0) continue;
    parts.push({ priceMinor: batch.priceMinor, qty: take });
    remaining -= take;
  }
  if (remaining > 0) parts.push({ priceMinor: line.priceMinor, qty: remaining });
  return parts;
}

export function cartLineAmounts(line: PricedCartLine, digits: 0 | 2): LineAmounts {
  if (!Number.isFinite(line.qty) || line.qty <= 0) return NOTHING;
  try {
    return sumLines(
      fefoParts(line).map((part) =>
        computeLine({ digits, unitPriceMinor: part.priceMinor, qty: part.qty, discountPct: line.discountPct, taxPct: line.taxPct }),
      ),
    );
  } catch {
    return NOTHING;
  }
}

export function cartAmounts(lines: PricedCartLine[], digits: 0 | 2): LineAmounts {
  return sumLines(lines.map((line) => cartLineAmounts(line, digits)));
}
